var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id && _vm.label)?_c('label',{staticClass:"label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label)+" "),(_vm.lblInfo)?_c('span',{staticClass:"label__info"},[_vm._v(_vm._s(_vm.lblInfo))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }